import React, { useState } from "react";
import Header from "../../Components/header";
import Footer from "../../Components/footer";
import "../../assets/css/style.scss";
import aboutBanner from "../../assets/images/about-bg.jpg"


const Contactus = () => {
    return (
        <>
            <div className="wrapper">
                <Header />
                <div className="image-box-container" style={{backgroundImage: `url(${aboutBanner})`}}>
                    <div className="overlay-colored-Bg"></div>
                    <div className="container">
                        <div className="center-content">
                            <div className="banner-title">
                                <h1>Contact Us</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <section>
                    <div className="container">
                    <div className="row contact-us-content mt-4 mb-5">
                        <div className="col-12 mb-3 text-center">
                        <h2 className="small-title--mt mb-3">~ Contact Us ~</h2>
                        <h2 className="heading-txt-web mb-0 text-center">Feel free to contact with us <br></br> any time.</h2>
                        </div>
                    </div>
                    </div>
                </section>
                <section className="py-5 mt-md-5 mb-4">
                    <div className="container">
                    <div className="row panel-grid panel-no-style px-5">
                        <div className="col-12 col-md-4 panel-grid-cell mb-5">
                        <div className="contact-panels">
                            <div className="contact-icon-box">
                            <span className="contact-icon"><i class="fal fa-envelope"></i></span>
                            </div>
                            <h5 className="text-center">EMAIL</h5>
                            <p className="text-center mt-2">grocerydeliverygomyfood@gmail.com</p>
                        </div>
                        </div>
                        <div className="col-12 col-md-4 panel-grid-cell mb-5">
                        <div className="contact-panels">
                            <div className="contact-icon-box">
                            <span className="contact-icon"><i class="far fa-phone-alt"></i></span>
                            </div>
                            <h5 className="text-center">PHONE</h5>
                            <p className="text-center mt-2">+91-8309060700</p>
                        </div>
                        </div>
                        <div className="col-12 col-md-4 panel-grid-cell mb-5s">
                        <div className="contact-panels">
                            <div className="contact-icon-box">
                            <span className="contact-icon"><i class="fas fa-map-marker-alt"></i></span>
                            </div>
                            <h5 className="text-center">ADDRESS</h5>
                            <p className="text-center mt-2">India, more suprmarket RK school </p>
                        </div>
                        </div>
                    </div>
                    </div>
                </section>
            
                
                <Footer />
            </div>
        </>
    )
}
export default Contactus;